import { MapAreaStyle } from "@shared/components/map/map-styles.model";
import { ColorStatusRendererComponent } from "@shared/components/table/renderers/color-status-renderer/color-status-renderer.component";
import { LinkRendererComponent } from "@shared/components/table/renderers/link-renderer/link-renderer.component";
import { ColumnMetadata } from "@valg-shared/components/table/table/column-metadata";
import { TableDataItem } from "@valg-shared/components/table/table/table.component";
import { WithPropsOfType } from "@valg-shared/forms";
import { sortByDanishLanguageRules } from "utils/sort-utils";

export interface StatusPollingDistrict extends TableDataItem {
  nominationDistrict: string;
  status: MapAreaStyle;
}


export const StatusPollingDistrictColumnDef: WithPropsOfType<StatusPollingDistrict, ColumnMetadata> = {
  nominationDistrict: { 
    title: 'status_polling_district.table.polling_district',
    presentationComponent: LinkRendererComponent,
    sortable: true,
    defaultSort: 'asc',
    sortFunction: sortByDanishLanguageRules,
    rendererOptions: new Map().set('link', 'polling-district'),
  },
  status: { 
    title: 'status_polling_district.table.status', 
    presentationComponent: ColorStatusRendererComponent,
    sortable: true
  },
  id: { title: 'id', disable: true },
}; 